import React from 'react';

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';
import CustomerSearchItem from './CustomerSearchItem';
import SortableTh from '../shared/table/SortableTh';
import ListView from '../shared/lists/ListView';
import useFilter from '../../utilities/useFilter';
import ExportButton from '../shared/buttons/ExportButton';
import SearchBar from '../shared/search/SearchBar';

const CustomerSearchList = ({
    navigateUrl
}) => {
    const editUrl = '/customers/edit/';
    const getUrl = '/api/customers/list';
    const defaultFilter = { sortColumn: 'DateCreated', sortDesc: true}


    const { items, filter, setFilter, pageInfo, isLoaded, submitFilter } = useFilter(getUrl, defaultFilter, true);

    const tableHead = (
        <thead>
            <tr>
                <SortableTh
                    content="First Name"
                    sort={pageInfo}
                    hide="xl"
                    sortName="FirstName"
                />
                <SortableTh
                    content="Last Name"
                    sort={pageInfo}
                    hide="xl"
                    sortName="LastName"
                />
                <SortableTh
                    className="d-table-cell d-xl-none"
                    content="Name"
                    sort={pageInfo}
                    sortName="FirstName"
                    width="130px"
                />
                <SortableTh
                    content="Email"
                    sort={pageInfo}
                    hide="sm"
                    sortName="Email1"
                />
                <SortableTh
                    content="Address"
                    sort={pageInfo}
                    hide="md"
                    sortName="AddressLine1"
                />
                <SortableTh
                    content="City"
                    sort={pageInfo}
                    sortName="City"
                    width="130px"
                />
                <SortableTh
                    content="State"
                    sort={pageInfo}
                    hide="lg"
                    sortName="StateName"
                    width="70px"
                />
                <SortableTh
                    content="Zip"
                    sort={pageInfo}
                    hide="lg"
                    sortName="Zip"
                    width="90px"
                />
                <SortableTh
                    content="Phone"
                    sort={pageInfo}
                    hide="sm"
                    sortName="PrimaryPhone"
                    width="145px"
                />
                {window.biztrax.showFranchise &&
                    <SortableTh
                        content="Franchise"
                        sort={pageInfo}
                        hide="lg"
                        sortName="FranchiseName"
                    />
                }
                <th className="button-cell" style={{ width: "40px" }}>
                    <ExportButton
                        disabled={items === undefined || items === null || items.length === 0}
                        filter={filter}
                        url="/api/export/customers"
                    />
                </th>
            </tr>
        </thead>
    );

    const listItems = items && items.map((item, index) =>
        <CustomerSearchItem
            editItem={() => navigateUrl(editUrl + item.id)}
            fetchData={filter.submitFilter}
            item={item}
            key={item.id}
        />
    );

    return (
        <React.Fragment>
            <SearchBar filter={filter} setFilter={setFilter} submitFilter={submitFilter} />
            <Row>
                <Col>
                    <ListView
                        animate={false}
                        canAdd={false}
                        items={listItems}
                        tableHead={tableHead}
                        isLoaded={isLoaded}
                        pageInfo={pageInfo}
                    />
                </Col>
            </Row>
        </React.Fragment>
    );
}

export default CustomerSearchList;